import { useForm } from '@mantine/form';

import { botTypes } from '../types';
import { validations } from '../validations';

type BotPageFormProps = {
  initialValues: botTypes.PageFormValues;
};

export const useBotPageForm = ({ initialValues }: BotPageFormProps) => {
  return useForm<botTypes.PageFormValues>({
    initialValues: {
      name: initialValues.name,
      externalId: initialValues.externalId,
      department: initialValues.department,
      subDepartment: initialValues.subDepartment,
      appPages: initialValues.appPages || [],
      isExpert: initialValues.isExpert || false,
      isMandatoryManagerSelect: initialValues.isMandatoryManagerSelect || false,
    },

    clearInputErrorOnChange: true,

    validate: {
      name: (v) => validations.isRequired(v, 'Name'),
      externalId: (v) => validations.isRequired(v, 'Id'),
      department: (value) => (!value ? 'Department is required' : null),
      subDepartment: (value) => (!value ? 'Sub-department is required' : null),
      appPages: (value) => {
        if (value) {
          const hasEmpty = value.some((page) => !page || page.trim() === '');
          return hasEmpty ? 'The page can not be empty' : null;
        }
      },
    },
  });
};
